/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PresignedUrlResponseDto = {
    /**
     * Whether this item was processed successfully
     */
    success: boolean;
    /**
     * Error message if the item failed
     */
    error?: string;
    /**
     * Storage provider that generated this URL
     */
    provider: PresignedUrlResponseDto.provider;
    /**
     * Pre-signed URL for direct upload to storage
     */
    uploadUrl: string;
    /**
     * Form fields required for S3 POST upload (createPresignedPost). Send these as part of the multipart/form-data request.
     */
    fields: Record<string, any>;
    /**
     * S3 file key to be used in confirm upload
     */
    fileKey: string;
    /**
     * URL expiration time in seconds
     */
    expiresIn: number;
};
export namespace PresignedUrlResponseDto {
    /**
     * Storage provider that generated this URL
     */
    export enum provider {
        AWS = 'AWS',
        AZURE = 'AZURE',
    }
}

